@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<div class="span9">
  <h1 data-automation-name="marketContextIndex">Market Contexts</h1>
</div>
<p class="lead">
  Market Contexts are a required component of an OADR dispatch event that indicates the Operator and Program of the event.
  <br>They may be optionally associated to some Groups so that a Market Context will always dispatch those Group(s) when the Market Context is received.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align:right; margin-bottom: 10px">
    <a id="createMarketContext" class="btn btn-large btn-primary" (click)="nextPage($event, '/createMarketContext', router)" style="margin-top:9px;">Create Market Context</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Market Contexts...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>ID</th>
      <th>Market Context URI</th>
      <th>Operator</th>
      <th>Program</th>
      <th>Product</th>
      <th># Events</th>
      <th># Vens</th>
      <th># Groups</th>
      <th>Label</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Market Context URI" class="input-sm form-control" type="search" [(ngModel)]="marketContextUriSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Operator" class="input-sm form-control" type="search" [(ngModel)]="operatorSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Program" class="input-sm form-control" type="search" [(ngModel)]="programSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Product" class="input-sm form-control" type="search" [(ngModel)]="productSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th></th>
      <th></th>
      <th><input placeholder="Label" class="input-sm form-control" type="search" [(ngModel)]="labelSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Modified By" class="input-sm form-control" type="search" [(ngModel)]="updatedBySearch" (input)="triggerSearch()"/></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(marketContext of displayedMarketContexts | paginate: paginationModel; track marketContext) {
        <tr>
          <td>{{marketContext.id}}</td>
          <td>{{marketContext.market_context}}</td>
          <td>{{marketContext.operator}}</td>
          <td>{{marketContext.program}}</td>
          <td>{{marketContext.product}}</td>
          <td>{{marketContext.events.length || 0}}</td>
          <td>{{marketContext.vens.length || 0}}</td>
          <td>{{marketContext.groups.length || 0}}</td>
          <td>{{marketContext.label}}</td>
          <td id="updated_by">{{marketContext.updated_by}}</td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a id="edit" class="btn btn-default" (click)="nextPage(marketContext.id, '/editMarketContext', router)" name="editMarketContext">Edit</a>
                <button id="delete" class="btn btn-danger" type="button" (click)="delete(marketContext)">Delete</button>
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedMarketContexts.length === 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 11 : 10" style="text-align: center;">No market contexts found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 11 : 10">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
